// ============================================
// App Module - Keyboard (ES6)
// Android WebView 키보드 처리
// ============================================

import { handleKeyDown } from '../chat/message-actions.js';

// ============================================
// 키보드 핸들링 초기화
// ============================================

export function initKeyboardHandling() {
  const isCapacitor = typeof Capacitor !== 'undefined' &&
                      Capacitor.isNativePlatform &&
                      Capacitor.isNativePlatform();

  if (!isCapacitor) {
    console.log('[Keyboard] Not Capacitor environment');
    return;
  }

  const Keyboard = Capacitor.Plugins?.Keyboard;
  if (!Keyboard) {
    console.log('[Keyboard] Keyboard plugin not found');
    return;
  }

  console.log('[Keyboard] Initializing keyboard handling');

  Keyboard.addListener('keyboardWillShow', (info) => {
    console.log('[Keyboard] keyboardWillShow', info.keyboardHeight);
    document.body.classList.add('keyboard-visible');
    document.documentElement.style.setProperty('--keyboard-height', `${info.keyboardHeight}px`);

    requestAnimationFrame(() => {
      setTimeout(() => {
        const container = document.getElementById('messagesContainer');
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      }, 50);
    });
  });

  Keyboard.addListener('keyboardWillHide', () => {
    console.log('[Keyboard] keyboardWillHide');
    document.body.classList.remove('keyboard-visible');
    document.documentElement.style.setProperty('--keyboard-height', '0px');
  });
}

// ============================================
// 메시지 입력 리스너 초기화
// ============================================

export function initMessageInputListener() {
  const messageInput = document.getElementById('messageInput');
  if (!messageInput) return;

  messageInput.addEventListener('keydown', handleKeyDown);
  console.log('[MessageInput] Event listener attached');
}

// ============================================
// 초기화 실행
// ============================================

function init() {
  initKeyboardHandling();
  initMessageInputListener();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// ============================================
// window 함수 노출 (기존 코드 호환성)
// ============================================

window.initKeyboardHandling = initKeyboardHandling;
window.initMessageInputListener = initMessageInputListener;
